const formatMoney = (num, showTrailingZeros, currency = "USD") => {
  const fractionDigits = showTrailingZeros ? 2 : (num * 100) % 100 === 0 ? 0 : 2;

  return new Intl.NumberFormat("en-EN", {
    style: "currency",
    currencyDisplay: "narrowSymbol",
    currency,
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(num);
};

class PriceSnippet extends HTMLElement {
  static observedAttributes = ["dynamic", "price", "compare-at-price", "currency", "trailing-zeros"];

  connectedCallback() {
    this._init();
  }

  attributeChangedCallback() {
    if (!this.isConnected) return;

    this._init();
  }

  get price() {
    return parseFloat(this.getAttribute("price")) || 0;
  }

  get compareAtPrice() {
    return parseFloat(this.getAttribute("compare-at-price")) || 0;
  }

  get currency() {
    return this.getAttribute("currency") || "USD";
  }

  get trailingZeros() {
    return this.hasAttribute("trailing-zeros") ? 2 : 0;
  }

  get dynamic() {
    return this.hasAttribute("dynamic");
  }

  _init() {
    if (!this.dynamic) return;

    const onSale = this.compareAtPrice > 0 && this.compareAtPrice > this.price;

    if (onSale) {
      this.innerHTML = `
        <span>
          <span class="visually-hidden">
            ${window.priceStrings?.regularPrice || "Regular price"}
          </span>
          <span>
            <s class="price__item price__item--original">
              ${formatMoney(this.compareAtPrice, this.trailingZeros, this.currency)}
            </s>
          </span>
        </span>

        <span>
          <span class="visually-hidden">
            ${window.priceStrings?.salePrice || "Sale price"}
          </span>
          <span class="price__item price__item--sale">
            ${formatMoney(this.price, this.trailingZeros, this.currency)}
          </span>
        </span>
      `;
    } else {
      this.innerHTML = `
        <span>
          <span class="visually-hidden">
            ${window.priceStrings?.regularPrice || "Regular price"}
          </span>
          <span class="price__item price__item--regular">
            ${formatMoney(this.price, this.trailingZeros, this.currency)}
          </span>
        </span>
      `;
    }
  }
}

if (!customElements.get("price-snippet")) {
  customElements.define("price-snippet", PriceSnippet);
}
